import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

// const firebaseConfig = {
//   apiKey: "AIzaSyAPfyflw5KW3p-p3yYXCc_-2iFapbcJ3Yo",
//   authDomain: "admin-react-cf431.firebaseapp.com",
//   projectId: "admin-react-cf431",
//   storageBucket: "admin-react-cf431.firebasestorage.app",
//   messagingSenderId: "728761369639",
//   appId: "1:728761369639:web:86f4049b89af6a490d3a02",
//   measurementId: "G-4RGX1CE2ZM"
// };
const firebaseConfig = {
  apiKey: "AIzaSyBQGFYE_EVql3T_B9cN7ucuXv6FGes0BcU",
  authDomain: "laravel-solar3.firebaseapp.com",
  projectId: "laravel-solar3",
  storageBucket: "laravel-solar3.firebasestorage.app",
  messagingSenderId: "506780973221",
  appId: "1:506780973221:web:738b63ba9c3fa80aa2354c",
  measurementId: "G-903K9XT9CW"
};
const app = initializeApp(firebaseConfig);

const messagingPromise = isSupported()
  .then(supported => (supported ? getMessaging(app) : null));


export const requestPermission = async () => {
  console.log("🔔 Requesting notification permission...");
  const messaging = await messagingPromise;
  if (!messaging) return null;

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    console.warn('🚫 Notification permission denied.');
    return null;
  }

  try {
    const token = await getToken(messaging, {
      vapidKey: "BIl-fm1uI6ODyr_VLRm8zeW8Mtku4mRgd9AczDhpD2ipvSSWEtiEpsSFkgU42aYLDfYA4D9GxISbN7_bPrmdGU8"
      // vapidKey: "BAhNzHsInNQGq9WwXnNeJNKgV3JyGLhPvrYZCPBc4YXkwpdT263Tp2wPqT7EVVgwVMSk9XSUVyOxMn9QNnBVQ0c"
    });
    console.log("✅ FCM token:", token);
    return token;
  } catch (err) {
    console.error("Error getting FCM token:", err);
    return null;
  }
};

export const onMessageListener = async () => {
  const messaging = await messagingPromise;
  if (!messaging) return;
  return new Promise(resolve => {
    onMessage(messaging, payload => {
      console.log("📩 foreground message:", payload);
      resolve(payload);
    });
  });
};
